module.exports = __webpack_public_path__ + "img/payoff-date-icon.5d650e90.svg";